export default __webpack_public_path__ + "navigation-examples-custom-waypoint-1200-2f4538b561cabe27cb6408221608c352.png";